import { call, put, select } from 'redux-saga/effects';

import * as types from './annuals.types';
import * as actions from './annuals.actions';
import * as api from '../../api/request-config/annuals.api';
import { apiRequest } from '../../api/api.saga-services';
import { ICreateAnnualPayload } from '../../page/annuals/annuals.types';
import { annualsSelectors } from './annuals.selectors';

export function* storeAnnuals(annuals: types.IAnnual[] | types.IAnnual) {
  yield put(actions.storeAnnual(annuals));
}

export function* getAnnuals() {
  const annuals: types.IAnnual[] = yield call(apiRequest, api.getAnnualsApi());
  yield call(storeAnnuals, annuals);
  return annuals;
}

export function* createAnnual(payload: ICreateAnnualPayload) {
  const result: types.IAnnual[] = yield call(apiRequest, api.createAnnualApi(payload));
  if (!result) {
    return;
  }
  return result;
}

export function* updateAnnual(annualId: types.IAnnual['id'], payload: ICreateAnnualPayload) {
  const result: types.IAnnual[] = yield call(apiRequest, api.updateAnnualApi(annualId, payload));
  if (!result) {
    return;
  }
  return result;
}

export function* deleteAnnual(annualId: types.IAnnual['id']) {
  const result: types.IAnnual[] = yield call(apiRequest, api.deleteAnnualApi(annualId));
  if (!result) {
    return;
  }
  return result;
}

export function* clearAnnual(annualId: types.IAnnual['id']) {
  yield put(actions.clearAnnual(annualId));
}

export function* clearAllAnnuals() {
  const boardListsIds: types.IAnnual['id'][] = yield select(annualsSelectors.selectResourceIds);
  yield put(actions.clearAnnual(boardListsIds));
}
